import { useState, useCallback } from 'react';
import { supabase } from '../lib/supabase';
import { toast } from 'react-hot-toast';

type LeadInput = {
  name?: string;
  email?: string;
  mobile: string;
  product?: string;
  quantity?: string;
  message?: string;
  source?: string;
};

export const useLeadSubmission = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const submitLead = useCallback(async (leadData: LeadInput) => {
    const { data: userData } = await supabase.auth.getUser();
    console.log('Supabase user context:', userData?.user);
    setIsSubmitting(true);
    setError(null);

    try {
      const newLead = {
        ...leadData,
        status: 'new' as const,
        source: leadData.source || 'website_form',
      };

      console.log('Submitting lead:', newLead);

      const { error: insertError } = await supabase
        .from('website_leads')
        .insert(newLead);

      if (insertError) {
        // Re-throw the error to be caught by the catch block
        throw insertError;
      }

      toast.success('Your inquiry has been submitted successfully!');
      return true;

    } catch (err) {
      console.error('Error submitting lead:', err);
      const errorMessage = err instanceof Error ? err.message : 'Failed to submit inquiry';
      setError(errorMessage);
      
      // Provide user-friendly error messages
      if (errorMessage.includes('row-level security policy')) {
        toast.error('Database configuration issue. Please contact support.');
        console.error('RLS Policy Error:', err);
      } else if (errorMessage.includes('network') || errorMessage.includes('fetch')) {
        toast.error('Network error. Please check your connection and try again.');
      } else {
        toast.error(errorMessage);
      }
      
      return false;
    } finally {
      setIsSubmitting(false);
    }
  }, []);

  return {
    isSubmitting,
    submitLead,
    error
  };
};